import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-progress-bar',
  template: `
    <div>
      <div class="la-progressBar"
           [ngClass]="{'la-progressBar--x-small': size === 'xsm',
         'la-progressBar--small': size === 'sm',
         'la-progressBar--medium': size === 'md'}">
        <la-image [src]="src"></la-image>
      </div>
    </div>
  `,
  styles: [`
    .la-progressBar{height:64px;width:64px}.la-progressBar--x-small{height:32px;width:32px}.la-progressBar--small{height:48px;width:48px}.la-progressBar--medium{height:64px;width:64px}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaProgressBarComponent {
  private _src: string;
  private _size = 'md';
  get src(): string {
    return this._src;
  }

  /**
   * path - to set image url
   */
  @Input()
  set src(src: string) {
    this._src = src;
  }

  /**
   * size of various size option of avatar: sm
   * md is default size
   */
  @Input()
  set size(name: string) {
    if (name === 'xsm' || name === 'sm' || name === 'md') {
      this._size = name.toLowerCase();
    } else {
      this._size = 'md';
    }
  }


  get size(): string {
    return this._size;
  }
}
